module.exports = __webpack_public_path__ + "img/animals_06_V.945e9c8f.webp";